import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ChatContact } from '../ai-broker-chat.models';

@Component({
  selector: 'app-chat-contact',
  standalone: true,
  imports: [CommonModule, AvatarModule, ButtonModule],
  template: `
    <div class="contact-card p-3 surface-card border-round-lg border-1 border-gray-300 flex align-items-center gap-3">
      <p-avatar [image]="data().profilePictureUrl" 
                [label]="!data().profilePictureUrl ? data().fullName.at(0) : ''"
                shape="circle" size="large"
                [styleClass]="!data().profilePictureUrl ? 'bg-primary-50 text-primary-700 font-bold' : ''">
      </p-avatar>
      <div class="flex-grow-1 min-width-0">
        <div class="font-bold text-900 truncate">{{ data().fullName }}</div>
        <div class="text-xs text-color-secondary uppercase tracking-wider font-semibold">{{ data().userRole || 'Shared Contact' }}</div>
      </div>
      <div class="flex gap-2">
        @if (data().mobileNumber) {
          <a [href]="'tel:' + data().mobileNumber" pButton icon="pi pi-phone" 
             class="p-button-rounded p-button-text p-button-sm p-button-secondary border-1 border-gray-300"></a>
        }
        @if (data().email) {
          <a [href]="'mailto:' + data().email" pButton icon="pi pi-envelope" 
             class="p-button-rounded p-button-text p-button-sm p-button-secondary border-1 border-gray-300"></a>
        }
      </div>
    </div>
  `,
  styles: [`
    .contact-card {
      min-width: 280px;
      max-width: 400px;
      margin: 0.5rem 0;
      transition: all 0.2s ease-in-out;
    }
    .contact-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      border-color: var(--primary-color);
    }
    .truncate {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatContactComponent {
  data = input.required<ChatContact>();
}
